export const CHANGE_PNR = 'CHANGE_PNR';
export const ON_RECEIVE_BOOKING_INFO = 'ON_RECEIVE_BOOKING_INFO';
export const ON_FAIL_BOOKING_INFO = 'ON_FAIL_BOOKING_INFO';
export const ON_VALID_BOOKING_INFO = 'ON_VALID_BOOKING_INFO';
export const ON_FAIL_PROVIDER_BOOKING_INFO = 'ON_FAIL_PROVIDER_BOOKING_INFO';
export const LOADING = 'LOADING_BOOKING_INFO';
export const CHANGE_GDS = 'CHANGE_GDS';